import * as React from "react";
import { useFormikContext } from "formik";
import styled from "styled-components";
import Button from "components/bootstrap/Button";
import { Spinner } from "components/common";
import { ButtonToolbar } from "components/bootstrap";
import AggregationElementSelect from "views/components/aggregationwizard/AggregationElementSelect";
import aggregationElements from "./aggregationElementDefinitions";
export const UPDATE_WIDGET_PREVIEW_BTN_TEXT = "Update preview";
const aggregationElementsByKey = Object.fromEntries(aggregationElements.map((element) => [element.key, element]));
const StyledButtonToolbar = styled(ButtonToolbar)`
  justify-content: space-between;
  margin-bottom: 10px;
`;
const onCreateElement = (elementKey, values, setValues) => {
  var _a;
  const aggregationElement = aggregationElementsByKey[elementKey];
  if (aggregationElement == null ? void 0 : aggregationElement.onCreate) {
    setValues(aggregationElement.onCreate(values));
  } else {
    setValues({
      ...values,
      [elementKey]: [...(_a = values[elementKey]) != null ? _a : [], {}]
    });
  }
};
const SelectContainer = styled.div`
  margin-left: 5px;
`;
const ElementsConfigurationActions = () => {
  const {
    dirty,
    isSubmitting: isUpdatingPreview,
    isValid,
    values,
    setValues
  } = useFormikContext();
  return /* @__PURE__ */ React.createElement(StyledButtonToolbar, null, /* @__PURE__ */ React.createElement(SelectContainer, { "data-testid": "add-element-section", className: "pull-left" }, /* @__PURE__ */ React.createElement(
    AggregationElementSelect,
    {
      onSelect: (elementKey) => onCreateElement(elementKey, values, setValues),
      aggregationElements,
      formValues: values
    }
  )), /* @__PURE__ */ React.createElement(Button, { bsStyle: "info", className: "pull-right", type: "submit", disabled: !isValid || isUpdatingPreview || !dirty }, isUpdatingPreview ? /* @__PURE__ */ React.createElement(Spinner, { text: "Updating preview...", delay: 0 }) : UPDATE_WIDGET_PREVIEW_BTN_TEXT));
};
export default ElementsConfigurationActions;
